export default __webpack_public_path__ + "static/media/Newsletter 024.ea0b0d7b.png";